///<reference path="../vendor.d.ts"/>

((($: JQueryStatic) => {
    $.fn.ahbCommentsEditor = function (options) {

        const settings = $.extend({
            addCommentUrl: null,
            saveCommentsUrl: null,
            sortCommentsUrl: null,
            updateMode: "immediate"
        }, options);

        return this.each(function () {

            // There could be multiple comments containers on the page, so always search for elements within this one.
            const commentsSection = $(this);

            // Use the post data container as the target container for AJAX updates. This way the contents will always be
            // refreshed with the latest concurrency/antiforgery tokens.
            const dataContainer = commentsSection.find("[data-usage='post_data_container']");

            function enableAddEditButtons(enabled) {
                Ahb.Utilities.enableElement(enabled, commentsSection.find("button[data-usage='add_comment'],button[data-usage='edit_comment']"));
            }

            // Add comment button
            commentsSection.on("click", "button[data-usage='add_comment']", function () {
                const clickedButton = $(this);

                //Adding and removing rows requires the viewModel to be refreshed
                Ahb.Utilities.ajaxPostData({
                    data: dataContainer.find("input,textarea").serializeArray(),
                    containerSelector: dataContainer,
                    triggerElement: clickedButton,
                    url: settings.addCommentUrl,
                    callback: () => {
                        // Disable all 'Change' buttons (we can't edit more than one at a time)
                        enableAddEditButtons(false);
                        refreshAll();
                    }
                });
            });

            // Change (edit) comment button
            commentsSection.on("click", "button[data-usage='edit_comment']", function () {
                // Disable all 'Change' buttons (we can't edit more than one at a time)
                enableAddEditButtons(false);

                const row = $(this).closest("tr[data-usage='comment_row']");

                row.data("edit-mode", "edit");

                const oldUpdateTime = $.trim(row.find("span[data-usage='updated_on']").text());
                const oldUser = $.trim(row.find("span[data-usage='updated_by']").text());

                // Hide the readonly cell and show the editable cell
                row.find("td[data-usage='comment_readonly']").hide();
                row.find("td[data-usage='comment_editable']").show();

                const readonlyComment = row.find("span[data-usage='comment_display']");
                let commentText = "~comment here~\n";
                commentText += `>> ${oldUser} on ${oldUpdateTime}\n`;
                commentText += readonlyComment.text();
                const commentContainer = row.find("[data-usage='comment_editor']");
                commentContainer.val(commentText);
                commentContainer[0].setSelectionRange(0, "~comment here~".length);
                commentContainer.focus();

                row.find(".elipsis").css('visibility', 'hidden');
                return false;
            });

            // Save comment being edited (actually submit all comments) button
            commentsSection.on("click", "[data-usage='submit_comments']", function () {

                const clickedButton = $(this);
                const entityId = commentsSection.find("input[data-usage='entity_id_container']").val();
                const isBatchUpdateMode = settings.updateMode === "batch";

                // only clear if it's not a batch update
                if (entityId && !isBatchUpdateMode) {
                    
                    // Clear the 'updated-on' value to indicate that the server should update it.
                    const row = $(this).closest("tr[data-usage='comment_row']");
                    row.find("input[data-usage='updated_on']").val("");
                    row.find("input[data-usage='updated_by']").val("");
                }

                // Only attempt to save if the entity ID has a value (i.e. it's an existing entity, not a new one)
                // and we're not in batch update mode. If it's a new one, just sort the comments.
                const url = (entityId && !isBatchUpdateMode) ? settings.saveCommentsUrl : settings.sortCommentsUrl;

                Ahb.Utilities.ajaxPostData({
                    data: dataContainer.find("input,textarea").serializeArray(),
                    containerSelector: dataContainer,
                    triggerElement: clickedButton,
                    url: url,
                    callback: () => {
                        const returnMessageContainer = commentsSection.find("span[data-usage='return_result']");
                        returnMessageContainer.text("comments saved").effect("highlight", {}, 3000).fadeOut(400);
                        enableAddEditButtons(true);
                        refreshAll();
                    }
                });
            });

            // Cancel comment being edited button
            commentsSection.on("click", "button[data-usage='cancel_comment']", function () {
                $("button[data-usage='edit_comment']").prop("disabled", false);

                const row = $(this).closest("tr[data-usage='comment_row']");

                if (row.data("edit-mode") === "add") {
                    row.remove();
                } else {
                    const originalComment = row.find("input[data-usage='original_comment']").val();
                    const commentContainer = row.find("[data-usage='comment_editor']");
                    commentContainer.val(originalComment);

                    row.data("edit-mode", "display");

                    // Hide the editor cell and display the readonly cell
                    $("td[data-usage='comment_editable']").hide();
                    $("td[data-usage='comment_readonly']").show();
                }

                enableAddEditButtons(true);
                refreshAll();
                return false;
            });

            // Expand all comments button
            commentsSection.on("click", "button[data-usage='expand_all_comments']", toggleAllExpanded);

            // Click on a row (toggles whether that row is expanded).
            commentsSection.on("click", "tr[data-usage='comment_row']", function () {
                const row = $(this);
                const expanded = row.data("display-mode") === "expanded";
                row.data("display-mode", expanded ? "collapsed" : "expanded");
                refreshExpandedState(row);
            });

            function toggleAllExpanded() {
                if ($("[data-usage='all_expanded_checkbox']").prop("checked")) {
                    // Already expanded. Collapse all.
                    $("input[data-usage='all_expanded_checkbox']").prop("checked", false);
                    $("tr[data-usage='comment_row']").data("display-mode", "collapsed");
                } else {
                    // Already collapsed. Expand all.
                    $("input[data-usage='all_expanded_checkbox']").prop("checked", true);
                    $("tr[data-usage='comment_row']").data("display-mode", "expanded");
                }

                // Refresh expanded state for all rows.
                refreshAll();
            }

            function refreshAll() {
                const commentRows = $("tr[data-usage='comment_row']");

                if (commentRows.length) {
                    dataContainer.show();
                } else {
                    dataContainer.hide();
                }

                commentRows.each(function () {
                    const row = $(this);
                    refreshEditableState(row);
                    refreshExpandedState(row);
                    refreshEllipsisVisibility(row);
                });
            }

            function refreshEditableState(row) {
                if (row) {
                    if (row.data("edit-mode") === "display") {
                        // Hide the editor cell and display the readonly cell
                        row.find("td[data-usage='comment_editable']").hide();
                        row.find("td[data-usage='comment_readonly']").show();
                    } else {
                        // Hide the readonly cell and display the editable cell
                        row.find("td[data-usage='comment_readonly']").hide();
                        row.find("td[data-usage='comment_editable']").show();

                        const commentContainer = row.find("[data-usage='comment_editor']");
                        try {
                            commentContainer.caret("~comment here~");
                            commentContainer[0].setSelectionRange(0, "~comment here~".length);
                        } catch (e) {
                        }
                    }
                } else {
                    // Call this function for every comment row.
                    $("tr[data-usage='comment_row']").each(function () {
                        refreshEditableState($(this));
                    });
                }
            }

            function refreshExpandedState(row) {
                if (row) {
                    const commentDisplaySpan = row.find("span[data-usage='comment_display']");

                    if (row.data("display-mode") === "expanded") {
                        commentDisplaySpan.addClass("expandedComment").removeClass("partComment");
                    } else {
                        commentDisplaySpan.removeClass("expandedComment").addClass("partComment");
                    }
                } else {
                    if ($("[data-usage='all_expanded_checkbox']").prop("checked")) {
                        $("button[data-usage='expand_all_comments']").text("Collapse all comments");
                    } else {
                        $("button[data-usage='expand_all_comments']").text("Expand all comments");
                    }

                    // Call this function for every comment row.
                    $("tr[data-usage='comment_row']").each(function () {
                        refreshExpandedState($(this));
                    });
                }
            }

            function refreshEllipsisVisibility(row) {
                if (row) {
                    // Display an ellipsis if the comment text is over a certain length or spans multiple lines.
                    // But if the comment is expanded or we're in edit mode, never display an ellipsis.
                    const commentDisplaySpan = row.find("span[data-usage='comment_display']");

                    const commentText = commentDisplaySpan.text();

                    const isLongComment = commentText.length > 70 || commentText.indexOf("\n") >= 0;

                    const isExpanded = row.data("display-mode") === "expanded";
                    const isEditing = (row.data("edit-mode") === "edit") || (row.data("edit-mode") === "add");

                    const ellipsisElem = row.find(".elipsis");

                    if (isLongComment && !isExpanded && !isEditing) {
                        // Display the ellipsis
                        ellipsisElem.css("visibility", "visible");
                    } else {
                        // Hide the ellipsis
                        ellipsisElem.css("visibility", "hidden");
                    }
                } else {
                    // Call this function for every comment row.
                    $("tr[data-usage='comment_row']").each(function () {
                        refreshEllipsisVisibility($(this));
                    });
                }
            }

            refreshAll();
        });
    };
})(jQuery));



// WEBPACK FOOTER //
// ./ScriptsTS/AhbCommentsEditor.ts